import { createFeatureSelector, createSelector } from '@ngrx/store';

import { SystemUpgradeState } from 'src/app/shared/services/ump';

import { GlobalState } from './global.state';
import { HealthStatus } from './interface';

export const selectGlobalState = createFeatureSelector<GlobalState>('global');

export const selectIsLoading = createSelector(
  selectGlobalState,
  (state: GlobalState) => state.isLoading
);

export const selectPickupOffline = createSelector(
  selectGlobalState,
  (state: GlobalState) => state.pickupOffline
);

export const selectPickupCodeOffline = createSelector(
  selectGlobalState,
  (state: GlobalState) => state.pickupCodeOffline
);

export const selectIsHealthy = createSelector(
  selectGlobalState,
  (state) => state.health?.status === HealthStatus.OK
);

export const selectHealth = createSelector(selectGlobalState, (state) => state.health);

export const selectHealthSpaces = createSelector(selectGlobalState, (state) => ({
  availableSpaces: state.health?.details?.availableSpaces?.count || 0,
  totalSpaces: state.health?.details?.totalSpaces?.count || 0,
}));

export const selectSessionActive = createSelector(
  selectGlobalState,
  (state) => state.isSessionActive
);

export const selectSystemUpgrade = createSelector(
  selectGlobalState,
  (state) => state.systemUpgrade
);

export const selectWitnessedUpgradeFailure = createSelector(
  selectGlobalState,
  (state) => state.witnessedUpgradeFailure
);

export const selectIsUpgradeBlocking = createSelector(
  selectSystemUpgrade,
  selectWitnessedUpgradeFailure,
  ({ state }, witnessedFailure) => {
    switch (state) {
      case SystemUpgradeState.IN_PROGRESS:
        return true;
      case SystemUpgradeState.FAILED:
        return witnessedFailure;
      default:
        return false;
    }
  }
);
